"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var Select_1 = require("../Select");
var propTypes = {
    options: PropTypes.arrayOf(PropTypes.number).isRequired,
    setItemsPerPage: PropTypes.func.isRequired,
    itemsPerPage: PropTypes.number,
    testId: PropTypes.string,
};
var PaginationSelect = function (_a) {
    var setItemsPerPage = _a.setItemsPerPage, options = _a.options, itemsPerPage = _a.itemsPerPage, testId = _a.testId;
    var selectOptions = options.map(function (num) { return ({
        label: "".concat(num, " Rows"),
        value: "".concat(num),
    }); });
    return (React.createElement(Select_1.Select, { name: "standardSelect", style: { width: 'inherit' }, options: selectOptions, inputProps: {
            onChange: function (event) {
                setItemsPerPage(+event.target.value);
            },
            value: itemsPerPage,
        }, "data-testid": testId }));
};
PaginationSelect.propTypes = propTypes;
exports.default = PaginationSelect;
